import type { ReactNode } from 'react';

interface HomeStatusBannerProps {
  action: ReactNode;
  description?: ReactNode;
  icon: ReactNode;
  title: ReactNode;
}

const HomeStatusBanner = ({
  action,
  description,
  icon,
  title,
}: HomeStatusBannerProps) => (
  <div className="flex w-full flex-col rounded-xl bg-white sm:flex-row sm:items-center">
    <div className="flex min-w-0 flex-1 items-start gap-3 p-4 sm:items-center">
      {icon}
      <div className="min-w-0 flex-1">
        {title}
        {description}
      </div>
    </div>
    <div className="flex w-full shrink-0 items-center px-4 pb-4 sm:w-auto sm:justify-end sm:p-4">
      {action}
    </div>
  </div>
);

export default HomeStatusBanner;
export type { HomeStatusBannerProps };
